export const numeroAleatorio = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min
}
